<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <label class="flex items-center relative w-max cursor-pointer select-none">
      <input
        :id="id"
        type="checkbox"
        class="mt-2 appearance-none transition-colors cursor-pointer w-14 h-7 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-offset-black focus:ring-blue-500 bg-red-500"
        :value="modelValue"
        :checked="modelValue"
        :disabled="disabled"
        @input="$emit('update:modelValue', toggleActive = !toggleActive)"
      />
      <span class="mt-2 absolute font-medium text-xs uppercase right-1 text-white" />
      <span class="mt-2 absolute font-medium text-xs uppercase right-8 text-white" />
      <span class="mt-2 w-7 h-7 right-7 absolute rounded-full transform transition-transform bg-gray-200" />
    </label>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `toggle-input-${uuid()}`
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: String,
    label: String,
    modelValue: Boolean,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      toggleActive: this.modelValue,
    }
  },
  watch: {
    selected(selected) {
      this.$emit('update:modelValue', selected)
    },
  },
}
</script>

<style>
input:checked {
  background-color: #22c55e;
}

input:checked ~ span:last-child {
  --tw-translate-x: 1.75rem;
}
</style>